export enum Environments {
  local = 'local',
  sandbox = 'sandbox',
  development = 'development',
  staging = 'staging',
  production = 'production',
}
export type LogLevels = 'DEBUG' | 'INFO' | 'ERROR'
export const currentEnvironment = (): Environments => {
  if (process.env.REACT_APP_LOCAL) {
    return Environments.local
  } else if ((process.env.REACT_APP_API_FQDN as string).includes('sandbox')) {
    return Environments.sandbox
  } else if (
    (process.env.REACT_APP_API_FQDN as string).includes('development')
  ) {
    return Environments.development
  } else if ((process.env.REACT_APP_API_FQDN as string).includes('staging')) {
    return Environments.staging
  }

  return Environments.production
}

export const logLevel = (loggerLevel: LogLevels): LogLevels => {
  if (currentEnvironment() === Environments.local) {
    return 'DEBUG'
  } else {
    return loggerLevel
  }
}

export const bytesToGbConverter = (size: number): number => {
  return size / (1000 * 1000 * 1000)
}

export const compositeCMSString = (
  cmsString: string,
  replacement: string | string[],
  replacing = '{0}',
): string => {
  try {
    if (Array.isArray(replacement)) {
      let replacedString = cmsString
      replacement.forEach((replace, index) => {
        replacedString = replacedString.replace(`{${index}}`, replace)
      })
      return replacedString
    } else {
      return cmsString.replace(replacing, replacement)
    }
  } catch (error) {
    // fail silently. don't worry it's safe
    return ''
  }
}

export const isObjectEmpty = (obj: any): boolean =>
  obj && Object.keys(obj).length === 0

export const isValidDate = (d: any): boolean => {
  return d instanceof Date && !isNaN(d.getTime())
}

export const formatDate = (date: string): string => {
  const newDate = new Date(date)

  return isValidDate(newDate)
    ? `${newDate.getMonth() + 1}/${newDate.getDate()}/${newDate.getFullYear()}`
    : ''
}

// zips 2 arrays in order - if the lengths are different, returns an array of the larger length with missing elements
// returned as undefined
export const zip = <T, U>(a1: T[], a2: U[]): [T?, U?][] => {
  if (a2.length > a1.length) {
    return a2.map((a, i) => [a1[i], a])
  } else {
    return a1.map((a, i) => [a, a2[i]])
  }
}

// from https://www.typescriptlang.org/docs/handbook/unions-and-intersections.html
export const assertNever = (x: never): never => {
  throw new Error('Unexpected object: ' + x)
}

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}
export const formatToSimpleDate=(inputDate: any)=>{
  if (!inputDate) return "";

  if (inputDate.$d && inputDate.$d instanceof Date) {
    const date = inputDate.$d;
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }

  if (inputDate instanceof Date) {
    return `${inputDate.getFullYear()}-${String(inputDate.getMonth() + 1).padStart(2, '0')}-${String(inputDate.getDate()).padStart(2, '0')}`;
  }

  return "";
}
export const handleFlatData = (file :any,flat: Record<string, string | string[]>) => {
  if(file==null){
    return flat
  }
  const formattedProfile = {
    firstName: [],
    middleName: [],
    lastName: [],
    phoneNumber: [],
    email: [],
    address: [{ city: '', state: '', zip: '', streetAddress: '' }],
    linkedIn: '',
    birthdate: '',
    mp_auth_letter_signature: '',
    missingFields: []
  }
  
  const arrayFields = ['firstName', 'middleName', 'lastName', 'email', 'phoneNumber']
  const addressFields = ['city', 'state', 'zip', 'streetAddress']
  
  for (const key in flat) {
    let value = flat[key]
  
    if (arrayFields.includes(key)) {
    // @ts-ignore
    formattedProfile[key] = [{ value }]
    } else if (key === 'linkedIn' || key === 'birthdate' || key === 'mp_auth_letter_signature') {
    
    if (key === 'birthdate' && typeof value === 'string' && value) {
      try {
        //@ts-ignore
        value = parseDate(value);
      } catch (err) {
        console.error("Invalid birthdate format:", value, err);
        value = "";
      }
    }
    
    // @ts-ignore
    formattedProfile[key] = value
    } else if (addressFields.includes(key)) {
    // @ts-ignore
    formattedProfile.address[0][key] = value
    } else if (key === 'missingFields') {
    // @ts-ignore
    formattedProfile.missingFields = value
    } else if (key === 'rowIndex') {
    // @ts-ignore
    formattedProfile.rowIndex = value
    }
  }
  return formattedProfile
  }

  export const parseDate = (DateString: string) => {
    try{const [day, month, year] = DateString.split("/").map(part => parseInt(part, 10));
  
    if (!day || !month || !year) {
      throw new Error("Invalid date parts");
    }
    if (month < 1 || month > 12) {
      throw new Error("Invalid month value");
    }
    if (day < 1 || day > 31) {
      throw new Error("Invalid day value");
    }
    const date = new Date(Date.UTC(year, month - 1, day));
    if (
      date.getUTCFullYear() !== year ||
      date.getUTCMonth() !== month - 1 ||
      date.getUTCDate() !== day
    ) {
      throw new Error("Invalid calendar date");
    }
  
    return date;
  }
    catch{
      return ''
    }
  };
  
  export const getCol4DisplayValue = (status: string): string => {
    if (status === 'not_found') return 'Not Found';
    if (['optout_in_progress', 'new'].includes(status)) return 'Removing';
    return 'Removed';
  }

  export const isAddressIncomplete = (address: any) => {
  const requiredFields = ['city', 'state', 'zip', 'streetAddress']
  return requiredFields.some(field => !address[field]?.trim())
}

export const formatPhoneNumber = (phone: string): string => {
  const stripped = phone.replace(/[^\d]/g, '')
  return `+1${stripped}`
}

export const formatPhoneNumbers = (phones: { value: string }[] = []) => {
  return phones.map((p) => ({ value: formatPhoneNumber(p.value) }))
}

export const formatPhoneNumberDisplay = (value?: string) => {
  if (!value) return '';

  const digits = value.replace(/\D/g, '');

  if (digits.length <= 3) return digits;
  if (digits.length <= 6)
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};

export function normalizeCity(value: string): string {
  if (!value) return "";

  let normalized = value.replace(/_/g, " ").trim();
  normalized = normalized
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return normalized;
}